import React from 'react'
import { Button } from '@crossfit/ui'
import classNames from 'classnames'
import { trackButtonEvent } from 'services/segment'
import { parseImageSrc } from 'utilities/images'
import { FullWidthPromoImage } from '../../types'
import style from './style.module.css'
const APPLICATION_URL = import.meta.env.VITE_AFFILIATE_APPLICATION_URL
import { Parallax } from 'react-parallax'

export type FullWidthPromoProps = {
  kickerHeadlineText?: string
  image: FullWidthPromoImage
}

const START_APPLICATION_TEXT = 'Start Application'

export default function FullWidthPromo(props: FullWidthPromoProps) {
  const { image } = props
  const { alt: bgImageAlt, src: imageSrc } = image
  const { srcSet: bgImageSrcSet, src: bgImage } = parseImageSrc(imageSrc)
  const submit = (e) => {
    trackButtonEvent({
      eventType: 'Clicked',
      component: 'Button',
      buttonText: START_APPLICATION_TEXT,
      buttonColor: 'cf-blue',
      buttonId: e.target.id,
      buttonStyle: e.target.className,
      appliedComponent: 'Full Width Promo',
      linkUrl: APPLICATION_URL,
      yPosition: e.currentTarget.getBoundingClientRect().top + window.scrollY,
    })
    location.href = APPLICATION_URL
  }
  return (
    <Parallax
      bgImage={bgImage}
      bgImageAlt={bgImageAlt}
      bgImageSrcSet={bgImageSrcSet}
      strength={75}
    >
      <div className={classNames(style.innerContent, style.darken)}>
        <div className={style.container}>
          <h1 className={style.header}>Apply for Affiliation</h1>
          <h3 className={style.description}>
            Ready to apply? Submit an application at any time. And remember, the
            cost of the Affiliate Starter Kit is applied to your first year’s
            affiliation fee!
          </h3>
          <Button variant='primary' onClick={submit} className={style.button}>
            {START_APPLICATION_TEXT}
          </Button>
        </div>
      </div>
    </Parallax>
  )
}
